var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy } from 'react';
export var ErrorDialog = function () {
    var _a;
    var componentContext = (_a = useOfficeComponentContext()) === null || _a === void 0 ? void 0 : _a.data;
    var ErrorDialogLazy = withLazyErrorBoundary(lazy(function () {
        return import(
        /*webpackChunkName: "error-dialog-component" */ '@office-start/error-dialog-component');
    }), 'ErrorDialog', {
        disabled: !componentContext,
        schedulePriority: IDLE_VERYLOW_PRIORITY,
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return React.createElement(ErrorDialogLazy, __assign({}, componentContext));
};
//# sourceMappingURL=ErrorDialog.js.map